import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Share } from '@capacitor/share';
import { CustomerService } from 'src/app/services/customer.service';
import { CustomerContact } from 'src/app/classes/customer-contact';
import { Feedback } from 'src/app/classes/feedback';

@Component({
  selector: 'app-share',
  templateUrl: './share.component.html',
  styleUrls: ['./share.component.scss'],
})
export class ShareComponent  implements OnInit {
  feedback!: Feedback
  currentUser = new CustomerContact()

  constructor(public activeModal: NgbActiveModal,
    private customerService: CustomerService
  ) { }

  ngOnInit() {
    this.customerService.current().subscribe(contact => {
      this.currentUser = contact
    })
  }

  async share() {
    await Share.share({
      title: $localize`Great job!`,
      text: (this.feedback.rating > 4 ? '⭐⭐⭐⭐⭐\n' : '⭐⭐⭐⭐\n') + this.feedback.feedback,
      url: 'https://nuuduu.com/' + $localize.locale + (this.currentUser.referral_code ? '/?r=' + this.currentUser.referral_code : ''),
    })
  }
}
